export const CONFIRM_NO_POST_TO_EXCHANGE_PASSPHRASE = 'BYPASS';
